import React from 'react';
import {connect} from "react-redux";
import Dialog from 'material-ui/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import {Link} from 'react-router';
import reactStringReplace from 'react-string-replace';
import moment from 'moment';
import {isEmpty} from "lodash";
import {withStyles} from '@material-ui/core/styles';

import {partialUpdateSubscription} from '../../actions/SubscriptionActions';
import chargeInstanceService from "../../services/ChargeInstanceService";

import TerminationSubDialog from './TerminationSubDialog.jsx';

 const styles = theme => ({
    button: {
      color: "white",
      textTransform: "initial",

    },
    buttons: {
      justifyContent: 'center'
    },
    confirmText: {
      fontWeight: 500,
      textAlign: 'center'
    }
});

const currentDate = moment(Date.now())
const currentDateFormated = currentDate.format("DD/MM/YYYY");

@connect ((store) =>{
	return {
		messages: store.messages.messages,
    customerAccount: store.account.userAccount.billingAccount.customerAccount,
    subscription: store.subscription.subscription
  }
})
class SubscriptionDialog extends React.Component {
    constructor() {
        super();
        this.state = {
            open: false,
            openRedirect: false
        };
    }

  handleConfirm = (event) => {
    event && event.preventDefault();
    const { subscription, dispatch } = this.props
    const { code : subCode = "", subscriptionRenewal: {autoRenew = false}} = subscription;
    const subData = {
      "code": subCode,
      "renewalRule":{
        "autoRenew": !autoRenew
      }
    }
    dispatch(partialUpdateSubscription(subData));
    this.setState({ open: false, openRedirect: true });
  };

  handleClose = () => {
    this.setState({open: false, openRedirect: false });
  }

  openRenewWindow = (event) => {
    event && event.preventDefault();
    this.setState({open:true}) ;
  }

  renderDialog = () => {

    const {classes, messages, subscription} = this.props;
    const {subscriptionRenewal: {autoRenew = false}} = subscription || {};
    const confirmationText = autoRenew ? messages["common.block.confirm.disable.renew"] : messages["common.block.confirm.enable.renew"];
    const confirmActionText = autoRenew ? messages["common.block.renew.enabled"] : messages["common.block.renew.disabled"];
    return (
      <div>
        <Dialog
          actionsContainerStyle={{ "text-align": "center"}}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
        >
          <h5 className={classes.confirmText}>{confirmationText}</h5>
          <DialogActions className={classes.buttons}>
            <Button onClick={this.handleClose} className="btn btn-theme-standard" variant="contained" >
              {messages["common.button.cancel"]}
            </Button>
            <Button onClick={this.handleConfirm} className="btn btn-theme-default text-center" variant="contained">
              {messages["common.button.validate"]}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          actionsContainerStyle={{ "text-align": "center"}}
          modal={false}
          open={this.state.openRedirect}
          onRequestClose={this.handleClose}
        >
          <h5 className={classes.confirmText}>{confirmActionText}</h5>
          <DialogActions className={classes.buttons}>
            <Link to={subscriptionDetails_url.path}>
              <Button onClick={this.handleClose} className="btn btn-theme-standard" variant="contained">
                {messages["common.button.return.to.subscription"]}
              </Button>
            </Link>
          </DialogActions>
        </Dialog>

      </div>
    )
  }

  render() {
    const {messages, subscription} = this.props;
    const {subscribedTillDate= "", subscriptionRenewal: {autoRenew = false}} = subscription;
    const terminationDate = subscribedTillDate ? moment(subscribedTillDate).format("DD/MM/YYYY") : messages["common.block.comment.subscription.end.date"] ;
    const descriptionText = autoRenew ? messages["common.block.comment.disable.renew"] : messages["common.block.comment.enable.renew"];
    const buttonText = autoRenew ? messages["common.button.disable.auto.renewal"]: messages["common.button.resume.auto.renewal"];
    return (
      <div >
        <div className="text-left">
          <p className="sousTitle title-of-box"> {messages["common.label.manage.subscription"]}</p>
        </div>
        <div className="box-amount-wide">
          <div className="text-center" style={{"marginBottom": "10px"}}>
            <p className="dialog-main-content">{descriptionText.replace("$terminationDate", terminationDate )}</p>
            <button className="btn btn-theme-default" onClick={this.openRenewWindow}>{buttonText}</button>
          </div>

          <div className="nb-text">
            <p>
              <a target="_blank" href={contact_us_url} rel="nofollow">
                {messages["common.block.contactus"]}
              </a>
            </p>
            {/* <p style={{ fontSize: "10px", "paddingLeft": "12px" }}><label >*</label>{messages["common.block.infoDetail"]}</p> */}
          </div>
          {this.renderDialog(terminationDate)}
        </div>
      </div>
      );

    }
  }
  export default withStyles(styles)(SubscriptionDialog);



// WEBPACK FOOTER //
// ./src/opencell/pages/client/SubscriptionDialog.jsx